export default {
  LoginPage: {
    label: {
      email: 'Email',
      password: 'Password',
    },
    btn: {
      'reset-password': 'Forgot your password?',
      submit: 'Log in with SSO',
      submitV1: 'Log in',
    },
  },
};
